export const namespace = "canvas/";
export const SET_SCALE = "SET_SCALE";
export const SET_OFFSET = "SET_OFFSET";
export const SET_HISTORY_LAST = "SET_HISTORY_LAST";

export const SET_STAGE_SIZE = "SET_STAGE_SIZE";
export const SET_MY_DRAWING_URL = "SET_MY_DRAWING_URL";
export const SET_SEND_RES = "SET_SEND_RES";
export const SET_PIXEL_RATIO = "SET_PIXEL_RATIO";
/**
 * 描きこみましたフラグ(描きこみ終了時のエフェクトとか表示用)
 * @type {string}
 */
export const SET_DRAWN = "SET_DRAWN";

/**
 * 保存ボタンの有効状態みたいなやつ
 * @type {string}
 */
export const SET_SAVABLE = "SET_SAVABLE";
